import { API } from '@/constant/constants'
import { CREATE_OR_EDIT_CUSTOM_MARKER, CUSTOM_MARKER } from '@/types'
import axiosClient from '../axiosClient'

export const customMarkerApi = {

  getAll(params: { interfaceId: number, floorId: number }) {
    const url = API.OPERATIONS.CUSTOM_MARKER.DEFAULT
    return axiosClient.get<CUSTOM_MARKER[]>(url, { params: params })
  },
  create(data: CREATE_OR_EDIT_CUSTOM_MARKER) {
    const url = API.OPERATIONS.CUSTOM_MARKER.DEFAULT
    return axiosClient.post<CUSTOM_MARKER[]>(url, data)
  },
  update(data: CREATE_OR_EDIT_CUSTOM_MARKER) {
    const url = API.OPERATIONS.CUSTOM_MARKER.DEFAULT
    return axiosClient.put<CUSTOM_MARKER[]>(url, data)
  },
  delete(interfaceId: number, id: number) {
    const url = API.OPERATIONS.CUSTOM_MARKER.DEFAULT
    return axiosClient.delete<CUSTOM_MARKER[]>(url, {
      params: { interfaceId, id },
    })
  }

}

export default customMarkerApi
